export { default } from './UserLoyalty';
